<template>
  <div class="components-dialog">
    <a-modal
      :width="900"
      :title="form.id ? $t('update') : $t('create')"
      :visible="dialog"
      :maskClosable="false"
      @cancel="cancel"
    >
      <template slot="footer">
        <a-button key="back" @click="cancel"> 取消 </a-button>
        <a-button
          key="submit"
          type="primary"
          :loading="loading"
          @click="confirm"
        >
          提交
        </a-button>
      </template>
      <a-form-model ref="ruleForm" :model="form" :rules="rules">
        <div class="item row">
          <a-form-model-item label="字典编号" prop="code">
            <a-input
              :disabled="form.parentId > 0"
              v-model="form.code"
              placeholder="请输入字典编号"
              :maxLength="maxLength"
            />
          </a-form-model-item>
        </div>
        <div v-if="form.parentId == 0" class="item">
          <a-form-model-item label="字典名称" prop="dictValue">
            <a-input
              v-model="form.dictValue"
              placeholder="请输入字典名称"
              :maxLength="maxLength"
            />
          </a-form-model-item>
          <a-form-model-item label="字典排序" prop="sort">
            <a-input-number
              style="width: 100%"
              v-model="form.sort"
              placeholder="请输入字典排序"
              :max="10000000"
            />
          </a-form-model-item>
        </div>
        <div v-else>
          <div class="item">
            <a-form-model-item label="字典名称" prop="dictValue">
              <a-input
                v-model="form.dictValue"
                placeholder="请输入字典名称"
                :maxLength="maxLength"
              />
            </a-form-model-item>
            <a-form-model-item label="上级字典">
              <a-input placeholder="请输入上级字典" :disabled="true" v-model="form.parentValue" />
            </a-form-model-item>
          </div>
          <div class="item">
            <a-form-model-item label="字典键值" prop="dictKey">
              <a-input
                v-model="form.dictKey"
                placeholder="请输入字典键值"
                :maxLength="maxLength"
              />
            </a-form-model-item>
            <a-form-model-item label="字典排序" prop="sort">
              <a-input-number
                style="width: 100%"
                v-model="form.sort"
                placeholder="请输入字典排序"
                :max="10000000"
              />
            </a-form-model-item>
          </div>
        </div>
        <div class="item">
          <a-form-model-item label="封存">
            <a-switch
              :defaultChecked="form.isSelected"
              :checked="form.isSelected"
              @change="onChange"
            />
          </a-form-model-item>
          <a-form-model-item label="字典备注" prop="remark">
            <a-input
              v-model="form.remark"
              placeholder="请输入字典备注"
              :maxLength="maxLength"
            />
          </a-form-model-item>
        </div>
      </a-form-model>
    </a-modal>
  </div>
</template>
<style lang="less">
.item.row .ant-form-item {
  width: 100%;
}
.item {
  display: flex;
  .ant-form-item {
    width: 50%;
    display: flex;
    .ant-form-item-label {
      width: 90px;
      text-align: right;
    }
    .ant-form-item-control-wrapper {
      flex: 1;
    }
  }
  .ant-checkbox-wrapper {
    width: 50%;
    margin: 0;
  }
}
</style>
<script>
import { DictBizServiceProxy } from "@/service-proxies/app-v2/system.service-proxies";
const api = new DictBizServiceProxy();
const options = {
  submit: api.submit.bind(api),
};
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    form: Object,
  },
  data() {
    return {
      rules: {
        code: [{ required: true, message: "字典编号必填", trigger: "blur" }],
        dictValue: [
          { required: true, message: "字典名称必填", trigger: "blur" },
        ],
        dictKey: [{ required: true, message: "字典键值必填", trigger: "blur" }],
        sort: [{ required: true, message: "字典排序必选", trigger: "blur" }],
      },
      ...options,
      maxLength: 255,
      loading: false,
    };
  },
  methods: {
    cancel() {
      this.$refs.ruleForm.clearValidate();
      this.$emit("close");
    },
    onChange(checked) {
      this.form.isSelected = checked;
    },
    confirm() {
      if (this.loading) {
        return;
      }
      if (this.form.disabled) {
        return this.$emit("close");
      }
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.form.isSealed = this.form.isSelected ? 1 : 0;
          this.submit(this.form).then((res) => {
            this.$emit('update');
            this.loading = false;
          }).catch(_=>{
            this.loading = false;
          });
        }
      });
    },
  },
};
</script>
